import { FormikProps } from "formik";
import { TestRequestAdvancedSearchRQ } from "../../api/models/advanced-search/TestRequestAdvancedSearchRQ";
import TestRequestPurpose from "../../api/models/test-request/TestRequestPurpose";
import PrioritySearchTerm from "../../api/models/test-request/PrioritySearchTerm";

export const MAX_FILTER_DEPTH = 5;
export const ADVANCED_SEARCH_FORM_FIELDS = ["substrates", "products", "testMethods"] as const;

export type AdvancedSearchFormFields = typeof ADVANCED_SEARCH_FORM_FIELDS[number];
export type AdvancedSearchForm = { [ASF in AdvancedSearchFormFields]: string[] } & {
  customer: string;
  terms: string[];
  purpose: TestRequestPurpose | "";
  priority: PrioritySearchTerm;
};

export const SEARCH_FORM_INITIAL_VALUES: AdvancedSearchForm = {
  substrates: [""],
  products: [""],
  testMethods: [""],
  customer: "",
  terms: [],
  purpose: "",
  priority: "" as PrioritySearchTerm,
};
export const SEARCH_FORM_LABELS: Record<AdvancedSearchFormFields, string> = {
  substrates: "Substrates",
  products: "Products",
  testMethods: "Test Methods",
};
export const SEARCH_FORM_HELPER_TEXT: Record<keyof AdvancedSearchForm, string> = {
  substrates: "",
  products: "",
  testMethods: "",
  customer: "",
  terms: "",
  purpose: "",
  priority: "",
};
export const ADVANCED_SEARCH_INITIAL = generateAdvancedSearch(SEARCH_FORM_INITIAL_VALUES);

export function getHelperText<T, U extends keyof T>(
  { errors, touched }: FormikProps<T>,
  fieldName: U,
  helperTextDict: Record<U, string>,
) {
  if (errors[fieldName] && touched[fieldName]) {
    return [errors[fieldName] || ""].join(" ");
  }
  return helperTextDict[fieldName];
}

export function generateAdvancedSearch(form: AdvancedSearchForm): TestRequestAdvancedSearchRQ {
  return { ...form, purpose: form.purpose || undefined };
}

export function formatAdvancedSearchObject(searchObj: TestRequestAdvancedSearchRQ) {
  searchObj.substrates = searchObj.substrates?.filter((substrate) => substrate !== "");
  searchObj.products = searchObj.products?.filter((product) => product !== "");
  searchObj.testMethods = searchObj.testMethods?.filter((testMethod) => testMethod !== "");

  if (searchObj.substrates && searchObj.substrates.length < 1) {
    searchObj.substrates = [""];
  }
  if (searchObj.products && searchObj.products.length < 1) {
    searchObj.products = [""];
  }
  if (searchObj.testMethods && searchObj.testMethods.length < 1) {
    searchObj.testMethods = [""];
  }

  return searchObj;
}
